export enum TipoAuditoriaContrato {
  RENEGOCIACAO = 'RENEGOCIACAO',
  REPACTUACAO = 'REPACTUACAO',
  LIQUIDACAO = 'LIQUIDACAO',
  CANCELAMENTO = 'CANCELAMENTO',
  DESISTENCIA_ADMINISTRATIVA = 'DESISTENCIA_ADMINISTRATIVA',
  ALTERACAO_VALOR_LIQUIDO = 'ALTERACAO_VALOR_LIQUIDO'
}
